import { User, UserRole } from "@/types"
import { EmployeeStatus, ResidencyType } from '@/contexts/employees/EmployeesContext';

// This helper function converts the UserProfile from AuthContext to a User type
export const userProfileToUser = (userProfile: unknown): User | null => {
  if (
    typeof userProfile === 'object' &&
    userProfile !== null &&
    'id' in userProfile &&
    'name' in userProfile &&
    'email' in userProfile &&
    'role' in userProfile &&
    'department' in userProfile &&
    'companyId' in userProfile &&
    'companyName' in userProfile &&
    'position' in userProfile &&
    'shift' in userProfile &&
    'status' in userProfile &&
    'residency' in userProfile
  ) {
    const up = userProfile as {
      id: string;
      name: string;
      email: string;
      role: string;
      department: string | string[];
      companyId: string;
      companyName: string;
      position: string;
      shift: string;
      status: string;
      residency: string;
    };
    return {
      id: up.id,
      name: up.name,
      email: up.email,
      role: up.role as UserRole,
      department: typeof up.department === 'string' ? up.department : '',
      companyId: up.companyId,
      companyName: up.companyName,
      position: up.position || '',
      shift: up.shift || '',
      status: up.status || EmployeeStatus.ACTIVE,
      residency: up.residency || ResidencyType.RESIDENT,
    };
  }
  return null;
}
